export const DEALER_PAGINATION_SIZE = 24;
export const DEALER_LISTING_PAUSED_STATE = 'PAUSED';
export const DEALER_LISTING_PUBLISHED_STATE = 'PUBLISHED';
